import { IconProps } from "../../types/icon";

export default function ArrowLeft({className}: IconProps) {

  return (
    <svg className={className} width="6.6px" height="11.8px" viewBox="0 0 6.6 11.8">
      <path fill="currentColor" d="M5.4,0.2c0.3-0.3,0.7-0.3,1,0c0.3,0.3,0.3,0.7,0,1L2.2,5.4c-0.3,0.3-0.3,0.7,0,1l4.2,4.2 c0.3,0.3,0.3,0.7,0,1c-0.3,0.3-0.7,0.3-1,0L0.2,6.4c-0.3-0.3-0.3-0.7,0-1L5.4,0.2z"/>
    </svg>
  )
}